import __CapabilityFiltersScss from './CapabilityFilters.scss';
import __CapabilityFiltersOutlookdesktopScss from './CapabilityFilters.outlookdesktop.scss';
import __CapabilityFiltersMacoutlookScss from './CapabilityFilters.macoutlook.scss';
import {
    placeTypeFilterAriaLabel,
    placeTypeConferenceRoom,
    placeTypeSpace,
} from './CapabilityFilters.locstring.json';
import { observer } from 'mobx-react-lite';
import { ComboBox, IComboBoxOption } from '@fluentui/react/lib/ComboBox';
import loc from 'owa-localize';
import React from 'react';
import { useClientStyles } from 'owa-react-hooks/lib/useClientStyles';
import { useModeStyles } from 'owa-react-hooks/lib/useModeStyles';
import { isFilterApplied } from '../../mutators/roomPanelMetricsMutators';

const styles = {
    base: __CapabilityFiltersScss,
    desktop: __CapabilityFiltersOutlookdesktopScss,
    mac: __CapabilityFiltersMacoutlookScss,
};
export interface PlaceTypeFilterProps {
    shouldGetSpaces: boolean;
    onChange: (shouldGetSpaces: boolean) => void;
    viewStateId: string | null;
}

export default observer(function PlaceTypeFilter(props: PlaceTypeFilterProps) {
    const { getClass } = useClientStyles(styles);
    const { getModeAwareClass } = useModeStyles(getClass);

    const options = [
        {
            key: 'confRoom',
            text: loc(placeTypeConferenceRoom),
            isSelected: !props.shouldGetSpaces,
        },
        { key: 'space', text: loc(placeTypeSpace), isSelected: props.shouldGetSpaces },
    ];

    const onChange = React.useCallback(
        (evt: any, option: IComboBoxOption) => {
            props.onChange(option.key === 'space');

            isFilterApplied(props.viewStateId);
        },
        [props.onChange, props.viewStateId]
    );

    return (
        <ComboBox
            openOnKeyboardFocus={true}
            selectedKey={props.shouldGetSpaces ? 'space' : 'confRoom'}
            multiSelect={false}
            options={options}
            onChange={onChange}
            useComboBoxAsMenuWidth={true}
            styles={{
                root: getClass('featureFilterComboBox'),
                rootPressed: getClass('featureFilterComboBoxActive'),
                rootFocused: getClass('featureFilterComboBoxActive'),
                input: getModeAwareClass('featureFilterInput'),
            }}
            caretDownButtonStyles={{
                root: getClass('featureFilterCaretDownButton'),
            }}
            comboBoxOptionStyles={{
                root: getClass('featureFilterOptionRoot'),
            }}
            ariaLabel={loc(placeTypeFilterAriaLabel)}
        />
    );
});
